import '../../../styles/Auth/servicePopup.css';

const ViewServicePopup = ({ data, onClose }) => {
    return (
        <div className="view-popup-overlay">
            <div className="view-popup-wrapper">
                {/* <Icon
                    icon={closeIcon}
                    className="popup-close-icon"
                     onClick={onClose}
                /> */}
                <div className="view-popup-card">
                    <h6 className="view-popup-title">service Details</h6>

                    <div className="view-popup-info">
                        <div className="service-view-image">
                            <img
                                src={`process.env.API_URL${data.serviceImageObject?.uri}` || "/assets/placeholder.png"}
                                // src="/assets/service.png"
                                alt="service"
                                className="view-popup-image"
                            />
                        </div>
                        <div className="service-popup-title">
                            <h6>{data.title}</h6>
                        </div>

                        <div className="stock-sold-container">
                            <div className="stock-sold">
                                <div className="service-sold">
                                    <p className="count">{data.sold || '272'}</p>
                                    <h6 className="label">Sold</h6>
                                </div>

                                <div className="vertical-divider"></div>

                                <div className="service-stock">
                                    <p className="count">{data.serviceStatus}</p>
                                    <h6 className="label">Status</h6>
                                </div>
                            </div>

                            <div className="price-section">
                                <div className="price-details">
                                    <div className="price-row">
                                        <span>Price</span>
                                        <span>GST</span>
                                        <span>Final Price</span>
                                    </div>
                                </div>

                                <div className="price-detail">
                                    <div className="price-row1">
                                        <span>₹{data.basePrice}</span>
                                        <span>{data.gstPercentage}%</span>
                                        <span>₹{data.finalPrice}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="Done-Button" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default ViewServicePopup;